"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _enums = _interopRequireDefault(require("../enums.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const componentNames = ['text', 'textCaption', 'textParagraph', 'textLabel', 'textTitle', 'textHeading', 'textAction', 'textInput'];
const config = {
  styleProperties: [_enums.default.properties.FONT_FAMILY, _enums.default.properties.FONT_SIZE, _enums.default.properties.FONT_WEIGHT, _enums.default.properties.LINE_HEIGHT, _enums.default.properties.FONT_VARIATION]
};
var _default = exports.default = componentNames.reduce((obj, name) => Object.assign(obj, {
  [name]: config
}), {});